module.exports = __webpack_public_path__ + "assets/img/type2.ca6ba326.png";